import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const shiftsApi = factory.get("shifts");

const initialState = {
  shift: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      user_id: "",
      date: dayjs().format("YYYY-MM-DD"),
      start_time: dayjs().format("YYYY-MM-DD HH:mm:00"),
      end_time: dayjs().format("YYYY-MM-DD HH:mm:00"),
    },
  },
  shifts: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const shiftsSlice = createSlice({
  name: "shifts",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.shift.dialog = !state.shift.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.shifts.data = payload.data.data;
      state.shifts.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      state.shifts.form.id = payload.id;
      state.shifts.form.name = payload.name;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state, action) => {
      state.shift.form = initialState.shift.form;
    },
  },
});

export const { setLoading, setDialog, setDataTable, setById, resetForm } =
  shiftsSlice.actions;

export default shiftsSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("shifts"));
    const res = await shiftsApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("shifts"));
  } catch (err) {
    dispatch(setLoading("shifts"));
    throw new Error(err);
  }
};
const deleteById = (id) => async (dispatch) => {
  try {
    await shiftsApi.delete(id);
    dispatch(
      showNotification({
        message: "تم حذف البيانات بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};
// const getById = (id) => async (dispatch) => {
//   try {
//     dispatch(setLoading("flexibility"));
//     const res = await flexibilityApi.getById(id);
//     dispatch(setById(res.data.data[0]));
//     dispatch(setDialog());
//     dispatch(setLoading("flexibility"));
//   } catch (err) {
//     dispatch(setLoading("flexibility"));
//     throw new Error(err);
//   }
// };
const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("shift"));
    const xdata = {
      ...data,
      start_time: dayjs(data.start_time).format("HH:mm"),
      end_time: dayjs(data.end_time).format("HH:mm"),
    };

    await shiftsApi.create(xdata);
    dispatch(getAll());
    dispatch(setDialog());
    dispatch(setLoading("shift"));
    return true;
  } catch (err) {
    dispatch(setLoading("shift"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

export const Shifts = {
  getAll,
  create,
  deleteById,
  //   getById,
};
